module.exports = __webpack_public_path__ + "static/img/img_member_c.bc43ca31.png";